import { render, staticRenderFns } from "./RoundRobinStage.vue?vue&type=template&id=30685dd5&scoped=true&"
import script from "./RoundRobinStage.vue?vue&type=script&lang=js&"
export * from "./RoundRobinStage.vue?vue&type=script&lang=js&"
import style0 from "./RoundRobinStage.vue?vue&type=style&index=0&id=30685dd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30685dd5",
  null
  
)

export default component.exports